import { render, staticRenderFns } from "./HeaderIcfaDetails.vue?vue&type=template&id=f2f66c76"
import script from "./HeaderIcfaDetails.vue?vue&type=script&lang=js"
export * from "./HeaderIcfaDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports